import Header from './Header';
import { IUserJson } from '@scale/shared/types/user';
import { SmsTable } from './SmsTable';
import React, { useState, useMemo } from 'react';

import { TextField, Banner, Icon } from '@scale/scaleui';
import { listSmsCommunications } from 'react-scale/corp/lib/api/growth';
import { useQuery } from 'react-query';

const SmsPage: React.FC<{ user: IUserJson }> = ({ user }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const smsCommunicationsQuery = useQuery('smsCommunications', listSmsCommunications);

  const filteredData = useMemo(() => {
    if (smsCommunicationsQuery.isLoading) return [];
    const data = smsCommunicationsQuery.data;
    if (data) {
      if (searchTerm.length > 0) {
        return data.filter((campaign: any) =>
          Object.values(campaign).some(
            (value: any) =>
              value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
          ),
        );
      }
      return data;
    }
    return [];
  }, [smsCommunicationsQuery.data, searchTerm]);

  return (
    <div className="p-8 flex flex-col gap-4">
      <Header user={user} />
      <Banner
        variant="info"
        title="Ready to Send SMS to Contributors?"
        cta={{
          label: (
            <div className="flex items-center h-full truncate">
              <span className="w-full">Submit Your Requests</span>
              <Icon variant="black" icon={['fas', 'external-link-alt']} />
            </div>
          ),
          onClick: () =>
            window.open(
              'https://linear.app/scale-epd/team/COMMS/new?template=71d8b94d-0894-489a-b582-7c2c76d7c3a0',
              '_blank',
            ),
        }}
        subtitle={`Approval is needed for contributor facing SMS comms. If you have Linear access, click the button to create a ticket. If not, go to #contributor-comms, type /asks, and hit enter.`}
      />
      <TextField
        className="w-[35%]"
        leadingIcon="search"
        id="search"
        value={searchTerm}
        onChange={(e: any) => {
          setSearchTerm(e.target.value);
        }}
        placeholder="Search by name, sms body, or creator first name..."
      />
      {!smsCommunicationsQuery.isLoading && <SmsTable data={filteredData ?? []} />}
    </div>
  );
};

export default SmsPage;
